export default __webpack_public_path__ + "static/macbook-front-8ddf0ec21950c9c4d9e4613163fcf6de.png";